import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHistoryEvent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.05 40q-1.2 0-2.1-.9t-.9-2.1v-5h6.2v-6.35q-1.9.15-3.8-.525A9.36 9.36 0 0 1 12.05 23v-2.9h-2.5L3 13.55q1.8-1.7 4.3-2.775T12.4 9.7q1.5 0 3.425.475T19.25 11.7V8H42v26.75q0 2.2-1.525 3.725T36.75 40zm6.2-8H34.5v2.75q0 1 .625 1.625T36.75 37t1.625-.625T39 34.75V11H22.25v2.85L34.3 25.9v2.15h-2.15l-6.3-6.3-.85 1q-.65.75-1.3 1.15a12 12 0 0 1-1.45.75zM10.9 17.1h4.15v4.45a7.4 7.4 0 0 0 1.675.825q.825.275 1.675.275 1.25 0 2.55-.675t1.9-1.375l.85-1-3.45-3.45a12.5 12.5 0 0 0-3.6-2.525 10 10 0 0 0-4.25-.925q-1.35 0-2.45.325T7.7 13.9zM31.5 35H16.05v2H32.2q-.3-.3-.5-.825A3.3 3.3 0 0 1 31.5 35" })
});
export default SvgHistoryEvent;
